<mat-form-field class="no-underline">
  <button mat-icon-button class="button-icon">
    <mat-icon matPrefix (click)="showPicker(); false;">access_time</mat-icon>
  </button>
  <input readonly matInput
         [formControl]="timeFormControl"
         (click)="showPicker(); false;"
  >
</mat-form-field>
